module.exports = __webpack_public_path__ + "img/JAMIL-HR ADMIN.d1f8ff9b.jpg";